import { render, staticRenderFns } from "./ToufangY4HistoryMatrix.vue?vue&type=template&id=4a7dcd3a&scoped=true&"
import script from "./ToufangY4HistoryMatrix.vue?vue&type=script&lang=js&"
export * from "./ToufangY4HistoryMatrix.vue?vue&type=script&lang=js&"
import style0 from "./ToufangY4HistoryMatrix.vue?vue&type=style&index=0&id=4a7dcd3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7dcd3a",
  null
  
)

export default component.exports